<template>
  <div class="collatral-template">
    <div class="collateral show-conn">
      <!-- 名称 + 地图 -->
      <div class="collateral-name">
        <p>担保物{{ index + 1 }}</p>
        <div class="btn-group" v-if="showMessage">
          <el-button
            type="text"
            icon="el-icon-location"
            @click="openMap"
            :disabled="!enabledMap"
            >估值地图</el-button
          >
        </div>
      </div>
      <!-- 基础信息 -->
      <div v-if="showMessage">
        <p class="base-info">所在地区：{{ data.pm_address_half }}</p>
        <p class="base-info">担保方式：{{ data.pm_guarantee_type }}</p>
        <p class="base-info">担保物类型：{{ data.pm_object_type_msg }}</p>
        <p class="base-info">担保物情况：{{ data.pm_object_msg }}</p>
      </div>


      <oss-preview-img :images="data.addons_format" />
    </div>
    <!-- map -->
    <el-drawer
      :title="data.pm_name"
      :visible.sync="map.show"
      size="100%"
      v-if="enabledMap"
    >
      <baidu-map
        :pm-object-type="data.pm_object_type"
        :address="data.pm_address_full"
        :mode="'hide-then-show'"
        ref="baiduMap"
      />
    </el-drawer>
  </div>
</template>

<script>
import OSSPreviewImg from "@/components/OSSPreviewImg";
import MapTemplate from "@/views/Template/map";

export default {
  name: "collateral-template",
  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Object || "",
      default: {}
    },
    showMessage: {
      type: Boolean,
      default: true
    }
  },

  components: {
    "oss-preview-img": OSSPreviewImg,
    "baidu-map": MapTemplate
  },

  data() {
    return {
      // 保物类型判断是否有权调用地图接口
      enabledMap: true,
      // 地图详情
      map: {
        show: false,
        title: ""
      }
    };
  },

  watch: {
    "data.pm_object_type": {
      immediate: true,
      handler(val) {
        this.getMapAuthByPmType(val);
      }
    },
    "map.show"(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.baiduMap.show(this.data.pm_address_full);
        });
      }
    }
  },

  methods: {
    // 打开地图
    openMap() {
      this.map.show = true;
    },

    // 根据担保物类型判断是否有权调用地图接口
    getMapAuthByPmType(pmObjectType) {
      const param = { pm_object_type: pmObjectType };

      this.$request.map_getValuationStatus(param).then(res => {
        if (res.code !== 0) {
          this.$Message.error(res.msg);
          return;
        }

        this.enabledMap = res.valuationStatus;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
